module.exports = __webpack_public_path__ + "img/bg_login.66da561a.png";